export const industries = [
  {
    name: "Healthcare & Life Sciences",
    slug: "healthcare",
    icon: "HeartPulse",
    image:
      "https://images.unsplash.com/photo-1666886573301-b5d526cfd518?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Data-driven care, modern platforms and specialized health IT talent.",
    overview: [
      "Healthcare and life sciences organizations operate in one of the most complex, regulated and data-intensive environments in the world. Interoperability, patient privacy and legacy systems all slow down modernization.",
      "AMVI helps providers, payers and life sciences companies unlock the value of their data, modernize applications and deploy AI responsibly — while meeting strict compliance and security expectations.",
      "We combine healthcare technology capability with specialized health IT and analytics talent to accelerate outcomes across the care and research lifecycle.",
    ],
    technology: [
      "Healthcare Analytics",
      "AI & Machine Learning",
      "Data Platforms",
      "Application Development",
      "Digital Transformation",
      "Systems Integration",
    ],
    talent: [
      "Healthcare IT Professionals",
      "Medical Coders",
      "Healthcare Analysts",
      "Data Analysts",
      "Data Engineers",
      "Project Managers",
      "Business Analysts",
    ],
    roles: [
      "Healthcare IT Professionals",
      "Medical Coders",
      "Healthcare Analysts",
      "Data Analysts",
      "Data Engineers",
      "Project Managers",
      "Business Analysts",
    ],
    cta: "Explore Healthcare Solutions",
  },
  {
    name: "Banking & Financial Services",
    slug: "financial-services",
    icon: "Landmark",
    image:
      "https://images.unsplash.com/photo-1645226880663-81561dcab0ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Digital banking, risk analytics and secure modernization.",
    overview: [
      "Financial institutions face relentless pressure to modernize digital experiences, strengthen risk and fraud controls, and comply with evolving regulation — all while protecting customer trust.",
      "AMVI delivers AI, data analytics and cloud capabilities that power digital banking, fraud detection and risk analytics, alongside application modernization for core systems.",
      "Our specialized financial services talent helps institutions build high-performing teams for critical, time-sensitive initiatives.",
    ],
    technology: [
      "AI & Machine Learning",
      "Data Analytics",
      "Digital Banking",
      "Cloud",
      "Risk Analytics",
      "Fraud Detection",
      "Application Modernization",
    ],
    talent: [
      "Financial Analysts",
      "Data Engineers",
      "Business Analysts",
      "Cloud Engineers",
      "Cybersecurity Professionals",
      "Project Managers",
    ],
    roles: [
      "Financial Analysts",
      "Data Engineers",
      "Business Analysts",
      "Cloud Engineers",
      "Cybersecurity Professionals",
      "Project Managers",
    ],
    cta: "Build Your Financial Services Team",
  },
  {
    name: "Manufacturing & Industrial",
    slug: "manufacturing",
    icon: "Factory",
    image:
      "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Smart manufacturing, IoT and predictive operations.",
    overview: [
      "Manufacturers are transforming operations with smart factories, IoT and data-driven decision making, while managing complex supply chains and aging systems.",
      "AMVI brings smart manufacturing technology, automation and predictive analytics together with specialized engineering talent to improve quality, uptime and throughput.",
      "From the plant floor to the enterprise, we help industrial organizations modernize and scale.",
    ],
    technology: [
      "Smart Manufacturing",
      "IoT",
      "Automation",
      "Predictive Analytics",
      "Supply Chain Technology",
      "Cloud",
      "Data Engineering",
    ],
    talent: [
      "Mechanical Engineers",
      "Electrical Engineers",
      "Manufacturing Engineers",
      "Controls Engineers",
      "Quality Engineers",
      "Process Engineers",
      "Production Managers",
    ],
    roles: [
      "Mechanical Engineers",
      "Electrical Engineers",
      "Manufacturing Engineers",
      "Controls Engineers",
      "Quality Engineers",
      "Process Engineers",
      "Production Managers",
    ],
    cta: "Find Manufacturing Talent",
  },
  {
    name: "Semiconductor & Electronics",
    slug: "semiconductor-electronics",
    icon: "Cpu",
    image:
      "https://images.unsplash.com/photo-1672307613484-3254a04651fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Specialized engineering across design, validation and manufacturing.",
    overview: [
      "AMVI helps semiconductor and electronics organizations access specialized engineering talent and technology capabilities across design, validation, manufacturing, embedded systems, testing and digital transformation.",
      "The semiconductor industry demands deep, hard-to-find expertise across the full product lifecycle. Talent scarcity and rapid innovation cycles put constant pressure on delivery timelines.",
      "We combine engineering staffing with data, automation and enterprise technology capability to help electronics organizations move faster with confidence.",
    ],
    technology: [
      "AI & Analytics",
      "Data Engineering",
      "Cloud",
      "Automation",
      "Digital Engineering",
      "Enterprise Applications",
    ],
    talent: [
      "Semiconductor Engineers",
      "Electrical Engineers",
      "Electronics Engineers",
      "Hardware Engineers",
      "Firmware Engineers",
      "Embedded Engineers",
      "Validation Engineers",
      "Verification Engineers",
      "Test Engineers",
      "Process Engineers",
      "Manufacturing Engineers",
      "Quality Engineers",
    ],
    roles: [
      "Semiconductor Engineers",
      "Electrical Engineers",
      "Electronics Engineers",
      "Hardware Engineers",
      "Firmware Engineers",
      "Embedded Engineers",
      "Validation Engineers",
      "Verification Engineers",
      "Test Engineers",
      "Process Engineers",
      "Manufacturing Engineers",
      "Quality Engineers",
    ],
    cta: "Build Your Semiconductor Team",
    featured: true,
  },
  {
    name: "Engineering & Technology",
    slug: "engineering-technology",
    icon: "Cog",
    image:
      "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Product, software and digital engineering at scale.",
    overview: [
      "Technology and engineering companies need to ship faster, scale teams and adopt emerging technology without compromising quality.",
      "AMVI provides software, product and digital engineering capability alongside specialized talent to help engineering organizations accelerate their roadmaps.",
      "From platform engineering to embedded systems, we help teams build and scale.",
    ],
    technology: [
      "Software Engineering",
      "Product Engineering",
      "Cloud & DevOps",
      "AI & Data",
      "Digital Engineering",
      "Automation",
    ],
    talent: [
      "Software Engineers",
      "DevOps Engineers",
      "Platform Engineers",
      "QA Engineers",
      "Solution Architects",
      "Engineering Managers",
    ],
    roles: [
      "Software Engineers",
      "DevOps Engineers",
      "Platform Engineers",
      "QA Engineers",
      "Solution Architects",
      "Engineering Managers",
    ],
    cta: "Scale Your Engineering Team",
  },
  {
    name: "Logistics & Supply Chain",
    slug: "logistics-supply-chain",
    icon: "Truck",
    image:
      "https://images.unsplash.com/photo-1645736315000-6f788915923b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Route optimization, visibility and warehouse automation.",
    overview: [
      "Supply chains are more complex and volatile than ever. Real-time visibility, forecasting accuracy and automation are now competitive necessities.",
      "AMVI delivers supply chain technology, analytics and automation capability, supported by talent that keeps operations moving.",
      "We help logistics organizations optimize routes, warehouses and networks end to end.",
    ],
    technology: [
      "Supply Chain Analytics",
      "IoT & Tracking",
      "Warehouse Automation",
      "AI & Forecasting",
      "Cloud",
      "Data Engineering",
    ],
    talent: [
      "Supply Chain Analysts",
      "Data Engineers",
      "Operations Managers",
      "Automation Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    roles: [
      "Supply Chain Analysts",
      "Data Engineers",
      "Operations Managers",
      "Automation Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    cta: "Optimize Your Supply Chain",
  },
  {
    name: "Automotive & Mobility",
    slug: "automotive",
    icon: "Car",
    image:
      "https://images.unsplash.com/photo-1567789884554-0b844b597180?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Connected vehicles, embedded systems and smart manufacturing.",
    overview: [
      "The automotive and mobility sector is being reshaped by electrification, autonomy and connected experiences, demanding new engineering and software capability.",
      "AMVI provides embedded, software and manufacturing engineering talent plus AI and data capability to support next-generation mobility programs.",
      "We help automotive organizations engineer smarter vehicles and factories.",
    ],
    technology: [
      "Embedded Systems",
      "Connected Vehicle",
      "AI & Data",
      "Smart Manufacturing",
      "Cloud",
      "Automation",
    ],
    talent: [
      "Embedded Engineers",
      "Software Engineers",
      "Electrical Engineers",
      "Mechanical Engineers",
      "Controls Engineers",
      "Quality Engineers",
    ],
    roles: [
      "Embedded Engineers",
      "Software Engineers",
      "Electrical Engineers",
      "Mechanical Engineers",
      "Controls Engineers",
      "Quality Engineers",
    ],
    cta: "Build Your Mobility Team",
  },
  {
    name: "Energy & Utilities",
    slug: "energy",
    icon: "Zap",
    image:
      "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Grid modernization, analytics and digital operations.",
    overview: [
      "Energy and utility organizations are modernizing grids, integrating renewables and adopting data-driven operations while ensuring reliability and compliance.",
      "AMVI brings analytics, cloud and automation capability together with engineering talent to support grid modernization and digital operations.",
      "We help energy providers become more efficient, resilient and sustainable.",
    ],
    technology: [
      "Grid Analytics",
      "IoT & Sensors",
      "AI & Forecasting",
      "Cloud",
      "Automation",
      "Data Engineering",
    ],
    talent: [
      "Electrical Engineers",
      "Data Engineers",
      "Controls Engineers",
      "Analysts",
      "Project Managers",
      "Cloud Engineers",
    ],
    roles: [
      "Electrical Engineers",
      "Data Engineers",
      "Controls Engineers",
      "Analysts",
      "Project Managers",
      "Cloud Engineers",
    ],
    cta: "Modernize Your Operations",
  },
  {
    name: "Telecommunications",
    slug: "telecommunications",
    icon: "RadioTower",
    image:
      "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "5G, network engineering and data-driven experiences.",
    overview: [
      "Telecom providers are scaling 5G, virtualizing networks and using data to deliver better customer experiences in a highly competitive market.",
      "AMVI delivers network engineering, cloud and data capability alongside specialized talent for large-scale telecom programs.",
      "We help operators build faster, smarter and more reliable networks.",
    ],
    technology: [
      "Network Engineering",
      "Cloud & Virtualization",
      "AI & Analytics",
      "Automation",
      "Data Engineering",
      "OSS/BSS Modernization",
    ],
    talent: [
      "Network Engineers",
      "Cloud Engineers",
      "Data Engineers",
      "Software Engineers",
      "Solution Architects",
      "Project Managers",
    ],
    roles: [
      "Network Engineers",
      "Cloud Engineers",
      "Data Engineers",
      "Software Engineers",
      "Solution Architects",
      "Project Managers",
    ],
    cta: "Build Your Telecom Team",
  },
  {
    name: "Retail & E-Commerce",
    slug: "retail",
    icon: "ShoppingBag",
    image:
      "https://images.unsplash.com/photo-1563013544-824ae1b704d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Personalization, forecasting and omnichannel commerce.",
    overview: [
      "Retailers compete on experience, personalization and speed. Unifying data across channels and forecasting demand are critical to growth.",
      "AMVI provides commerce, AI and data capability with talent to power personalization engines, forecasting and omnichannel platforms.",
      "We help retail brands turn data into loyalty and revenue.",
    ],
    technology: [
      "Personalization & AI",
      "Demand Forecasting",
      "Commerce Platforms",
      "Data & Analytics",
      "Cloud",
      "Application Development",
    ],
    talent: [
      "Data Engineers",
      "Software Engineers",
      "Data Analysts",
      "Cloud Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    roles: [
      "Data Engineers",
      "Software Engineers",
      "Data Analysts",
      "Cloud Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    cta: "Build Your Commerce Team",
  },
  {
    name: "Government & Public Sector",
    slug: "government",
    icon: "Building",
    image:
      "https://images.unsplash.com/photo-1618656172765-26774a4a38d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Digital government, secure platforms and citizen services.",
    overview: [
      "Government organizations are modernizing citizen services and infrastructure while meeting strict security and compliance requirements.",
      "AMVI delivers digital platforms, data and cloud capability with talent to support secure public sector transformation.",
      "We help agencies deliver better services to the people they serve.",
    ],
    technology: [
      "Digital Platforms",
      "Data & Analytics",
      "Cloud",
      "Cybersecurity",
      "Automation",
      "Application Modernization",
    ],
    talent: [
      "Cloud Engineers",
      "Data Engineers",
      "Cybersecurity Professionals",
      "Software Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    roles: [
      "Cloud Engineers",
      "Data Engineers",
      "Cybersecurity Professionals",
      "Software Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    cta: "Explore Public Sector Solutions",
  },
  {
    name: "Insurance",
    slug: "insurance",
    icon: "ShieldCheck",
    image:
      "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Underwriting analytics, claims automation and modernization.",
    overview: [
      "Insurers are modernizing core systems, automating claims and using analytics to improve underwriting and customer experience.",
      "AMVI delivers data, AI and application capability with specialized talent to support insurance transformation.",
      "We help carriers modernize with confidence.",
    ],
    technology: [
      "Underwriting Analytics",
      "Claims Automation",
      "AI & Data",
      "Cloud",
      "Application Modernization",
      "Integration",
    ],
    talent: [
      "Data Engineers",
      "Business Analysts",
      "Software Engineers",
      "Data Analysts",
      "Cloud Engineers",
      "Project Managers",
    ],
    roles: [
      "Data Engineers",
      "Business Analysts",
      "Software Engineers",
      "Data Analysts",
      "Cloud Engineers",
      "Project Managers",
    ],
    cta: "Build Your Insurance Team",
  },
  {
    name: "Construction & Infrastructure",
    slug: "construction",
    icon: "HardHat",
    image:
      "https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Digital construction, project data and engineering talent.",
    overview: [
      "Construction and infrastructure organizations are adopting digital tools to improve project delivery, safety and cost control.",
      "AMVI provides project data, analytics and application capability along with engineering and project talent.",
      "We help builders deliver complex projects on time and on budget.",
    ],
    technology: [
      "Project Analytics",
      "Digital Construction",
      "IoT",
      "Cloud",
      "Data Engineering",
      "Application Development",
    ],
    talent: [
      "Civil Engineers",
      "Project Managers",
      "Data Analysts",
      "Software Engineers",
      "Business Analysts",
      "Estimators",
    ],
    roles: [
      "Civil Engineers",
      "Project Managers",
      "Data Analysts",
      "Software Engineers",
      "Business Analysts",
      "Estimators",
    ],
    cta: "Build Your Project Team",
  },
  {
    name: "Aerospace & Defense",
    slug: "aerospace-defense",
    icon: "Plane",
    image:
      "https://images.unsplash.com/photo-1710267224163-0ee7e0d7a7ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Mission-critical engineering, systems and data.",
    overview: [
      "Aerospace and defense programs demand rigorous engineering, systems integration and compliance under exacting standards.",
      "AMVI provides specialized engineering, software and data talent alongside technology capability for complex programs.",
      "We help aerospace organizations engineer with precision and reliability.",
    ],
    technology: [
      "Systems Engineering",
      "Embedded Systems",
      "AI & Data",
      "Cloud",
      "Digital Engineering",
      "Simulation",
    ],
    talent: [
      "Systems Engineers",
      "Embedded Engineers",
      "Software Engineers",
      "Electrical Engineers",
      "Mechanical Engineers",
      "Quality Engineers",
    ],
    roles: [
      "Systems Engineers",
      "Embedded Engineers",
      "Software Engineers",
      "Electrical Engineers",
      "Mechanical Engineers",
      "Quality Engineers",
    ],
    cta: "Build Your Aerospace Team",
  },
  {
    name: "Professional Services",
    slug: "professional-services",
    icon: "Briefcase",
    image:
      "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Technology and talent to scale client delivery.",
    overview: [
      "Professional services firms need flexible technology and talent capacity to deliver client engagements at speed and scale.",
      "AMVI provides consulting, engineering and data capability plus specialized talent that extends your delivery teams.",
      "We help firms win and deliver more, without carrying fixed overhead.",
    ],
    technology: [
      "AI & Data",
      "Cloud & DevOps",
      "Application Development",
      "Automation",
      "Analytics",
      "Integration",
    ],
    talent: [
      "Consultants",
      "Software Engineers",
      "Data Engineers",
      "Cloud Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    roles: [
      "Consultants",
      "Software Engineers",
      "Data Engineers",
      "Cloud Engineers",
      "Business Analysts",
      "Project Managers",
    ],
    cta: "Extend Your Delivery Team",
  },
];

export const industryGroups = [
  "All",
  "Technology & Engineering",
  "Industrial & Manufacturing",
  "Finance & Business",
  "Health & Public",
];

const groupMap = {
  "healthcare": "Health & Public",
  "financial-services": "Finance & Business",
  "manufacturing": "Industrial & Manufacturing",
  "semiconductor-electronics": "Technology & Engineering",
  "engineering-technology": "Technology & Engineering",
  "logistics-supply-chain": "Industrial & Manufacturing",
  "automotive": "Industrial & Manufacturing",
  "energy": "Industrial & Manufacturing",
  "telecommunications": "Technology & Engineering",
  "retail": "Finance & Business",
  "government": "Health & Public",
  "insurance": "Finance & Business",
  "construction": "Industrial & Manufacturing",
  "aerospace-defense": "Technology & Engineering",
  "professional-services": "Finance & Business",
};

industries.forEach((i) => {
  i.group = groupMap[i.slug] || "Technology & Engineering";
});

export const getIndustry = (slug) => industries.find((i) => i.slug === slug);
